import { ScenarioChartContainer } from '@/styles/scenario';
import {
	defaultColorChartAtZero,
	defaultFontChartAtZero,
	drawLineAtZeroPlugin,
} from '@/utils/utils';
import { Chart } from 'react-chartjs-2';
import { useTheme } from 'styled-components';
import type {Theme as ThemeType} from '@/styles/Themes'

const options = {
	responsive: true,
	maintainAspectRatio: false,
};

interface DemandChartProps {
	scenario: Record<string | number, TValue>[];
	isSalesRegionSelected?: boolean;
	title: string;
}

const DemandChart: React.FC<DemandChartProps> = ({
	scenario,
	isSalesRegionSelected,
	title,
}) => {
	const theme = useTheme() as ThemeType;
	return (
		<ScenarioChartContainer>
			{scenario.length > 0 && (
				<Chart
					type='bar'
					data={{
						datasets: [
							{
								type: 'line',
								label: '%YoY Average',
								data: isSalesRegionSelected ? scenario[1] : scenario[0],
								backgroundColor: '#ed7d31',
								borderColor: '#ed7d31',
								yAxisID: 'y1',
							},
							{
								type: 'bar',
								label: 'Tonnes as is',
								data: isSalesRegionSelected ? scenario[2] : scenario[1],
								backgroundColor: theme.background.primary,
								yAxisID: 'y',
								barPercentage: 0.5,
							},
						],
					}}
					plugins={[drawLineAtZeroPlugin]}
					options={{
						...options,
						plugins: {
							title: {
								display: true,
								text: title,
							},
						},
						scales: {
							y: {
								type: 'linear',
								display: true,
								position: 'left',
								ticks: {
									font: defaultFontChartAtZero,
									color: defaultColorChartAtZero,
								},
							},
							y1: {
								type: 'linear',
								display: true,
								position: 'right',
								grid: {
									drawOnChartArea: false,
								},
								ticks: {
									font: defaultFontChartAtZero,
									color: defaultColorChartAtZero,
								},
							},
						},
					}}
				/>
			)}
		</ScenarioChartContainer>
	);
};

export default DemandChart;
